/**
 * MAHI — Discover (swipeable product feed).
 * Phase 1: gesture + mock data only, see components/discovery/DiscoveryFeed.
 * Not yet linked from the nav / not replacing /home — mounted at both
 * /discover and the domain root (see MahiApp.jsx), for review per the
 * phased build-and-review plan.
 *
 * Also the one place the session-entry animation runs (components/ui/MahiIntro).
 * It is mounted here rather than inside the feed so the feed stays a feed: the
 * intro is about arriving at MAHI, not about the deck, and the only thing the
 * feed needs to know is that it should hold MAHI's walkthrough until the
 * wordmark has landed — otherwise the tour's opening step plays out unseen
 * behind the intro's white ground and she is simply parked mid-screen when it
 * lifts. `introPending` is that one fact, and nothing else.
 */
import React, { useCallback, useEffect, useState } from 'react';
import DiscoveryFeed from '../components/discovery/DiscoveryFeed';
import MahiIntro from '../components/ui/MahiIntro';
import { markMahiIntroPlayed, shouldPlayMahiIntro } from '../components/ui/mahiIntroGate';

export default function MahiDiscover() {
  // Decided once, at mount. Read on every render it would flip to false the
  // moment the intro marked itself played, unmounting it mid-animation.
  const [intro, setIntro] = useState(shouldPlayMahiIntro);

  // Marked from an effect rather than from the initialiser above, even though
  // the initialiser is where the decision is made: StrictMode runs a lazy
  // initialiser twice in development, so a write in there would record the
  // intro as played before it had rendered once and it would never be visible
  // in local dev. Writing it here is idempotent under StrictMode's double
  // mount, and still lands before any navigation could bring us back.
  useEffect(() => { if (intro) markMahiIntroPlayed(); }, [intro]);

  const endIntro = useCallback(() => setIntro(false), []);

  return (
    <>
      <DiscoveryFeed introPending={intro} />
      {intro && <MahiIntro onDone={endIntro} />}
    </>
  );
}
